import D_Number, { addRoundParenWhenNeg } from './number';

const Customized_Currency_Map = {
  CNY: '¥',
};

export default class Amount extends D_Number {
  constructor({ value, currencyIsoCode }) {
    super(value);
    this.currency = currencyIsoCode;
  }

  static getCurrencySymbol(currencyIsoCode) {
    if (!currencyIsoCode) {
      return '';
    }
    if (Object.keys(Customized_Currency_Map).includes(currencyIsoCode)) {
      return Customized_Currency_Map[currencyIsoCode];
    }
    let result = '';
    try {
      result = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyIsoCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
        .format(0)
        .replace(/\d/g, '')
        .trim();
      return result;
    } catch (e) {
      return '$';
    }
  }

  toString(decPoints = 2) {
    const currencySymbol = Amount.getCurrencySymbol(this.currency);
    return addRoundParenWhenNeg(
      this,
      (_decPoints) => `${currencySymbol}${this._toString(_decPoints)}`,
    )(decPoints);
  }

  static format(data, decPoints) {
    return new Amount(data).toString(decPoints);
  }
  static formatWithCertainSuffix(value, suffix, decPoints, currency) {
    const res = super.formatWithCertainSuffix(value, suffix, decPoints);
    if (value < 0) {
      return `(${(Amount.getCurrencySymbol(currency) + res).trim()})`;
    }
    return `${Amount.getCurrencySymbol(currency)}${res}`;
  }
}

export const getCurrencySymbol = (currencyIsoCode) =>
  Amount.getCurrencySymbol(currencyIsoCode);

export const isNumber = (target) =>
  target !== '' && target !== null && !Number.isNaN(Number(target));
